<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      后亭站<br>
站点介绍<br>
后亭站位于宝安区宝安大道与新和大道交叉口以北，沿宝安大道呈南北向布置。该站为地下两层岛式车站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:10	23:41	11号线	4分钟	6分32秒<br>
碧头	06:41	00:25	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:10	23:41	11号线	4分34秒	6分钟<br>
碧头	06:41	00:25	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:10	23:41	11号线	4分37秒	6分钟<br>
碧头	06:41	00:25	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
宝安大道西侧（北）、学子围工业区、后亭雅苑、安业丰科技园<br><br>
B出入口:<br>
宝安大道西侧、沙松路、厚得群物流园<br><br>
C出入口:<br>
宝安大道东侧、水源居小区、衙边学子围工业区（A1）、鹏城中骏、同方创意园<br><br>
D出入口:<br>
宝安大道东侧（北）、巨基科技大厦、长安大厦、衙边学子围工业区（A2）、福金顺工业园、同方创意园
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坑梓街道办<br>
978、B675、M295、M384、M427、M478<br><br>
B出入口:<br>
公交站名： 坑梓街道办<br>
978、B675、M295、M384、M427、M434、M478<br><br>
B出入口:<br>
公交站名： 坑梓市场<br>
366、E34、M136、M361、高峰专线64路<br><br>
B出入口:<br>
公交站名： 龙田路口<br>
366、E34、M136、高峰专线64路<br><br>
B出入口:<br>
公交站名： 金田购物广场<br>
M396、M427、M434、M478、978、B675、E22、M295、M384<br><br>
C出入口:<br>
公交站名： 坑梓市场<br>
366、E34、M136、M361、高峰专线64<br><br>
D出入口:<br>
公交站名： 龙田路口<br>
366、E34、M136、M361、高峰专线64路<br><br>
D出入口:<br>
公交站名： 坪山妇幼<br>
978、B675、B950、M293、M297、M384、M396<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>